import GitHubIcon from '@mui/icons-material/GitHub'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import portfolio from '../../portfolio'
import './About.css'

const About = () => {
  const { name, title, description, contact } = portfolio
  const githubContact = contact?.find(c => c.type === 'GitHub')
  const linkedinContact = contact?.find(c => c.type === 'LinkedIn')

  return (
    <div className='about center'>
      {name && (
        <h1>
          Hi, I am <span className='about__name'>{name}.</span>
        </h1>
      )}

      {title && <h2 className='about__role'>{title}</h2>}
      <p className='about__desc'>{description}</p>

      <div className='about__contact center'>
        {githubContact && (
          <a
            href={githubContact.href}
            aria-label='github'
            className='link link--icon'
            rel="noreferrer" 
            target='_blank'
          >
            <GitHubIcon />
          </a>
        )}

        {linkedinContact && (
          <a
            href={linkedinContact.href}
            target='_blank'
            aria-label='linkedin'
            rel="noreferrer" 
            className='link link--icon'
          >
            <LinkedInIcon />
          </a>
        )}
      </div>
    </div>
  )
}

export default About
